const debug = false;
const initialMin = 50;
const initialMax = 150;

// SVG ICONS
const defaultIconSvg = `<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 23.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve"><style type="text/css">	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#3283CB;stroke-width:2;stroke-miterlimit:10;}</style><title>quadrato copy@1x</title><circle class="st0" cx="5" cy="5" r="3.8"/></svg>`;
const defaultIcon = new Image();
defaultIcon.src = 'data:image/svg+xml;base64,' + window.btoa(defaultIconSvg);
defaultIcon.width = 10;
defaultIcon.height = 10;


class GlucometerChart {

    constructor(el, options) {
        if(debug) {
            console.log('GlucometerChart: init in element with id \''+el+'\'', options);
        }

        this.container = document.getElementById(el);
        if(!this.container) {
            console.error('GlucometerChart: element with id \''+el+'\' not found', this.container);
            return;
        }

        this.options = options;

        const { data = [], fromDate, toDate, animation = true, showLine = false, fill = false } = options;

        this.fromDate = new Date(fromDate ?? '');
        this.toDate = new Date(toDate ?? '');

        // console.debug(fromDate, toDate, this.fromDate, this.toDate, this.fromDate.getTime(), this.toDate.getTime())

        this.container.className = "chart-container";
        this.canvas = document.createElement("canvas");
        this.canvas.id = el+'_canvas';
        // this.canvas.height = this.maxY * 6.5;
        //this.canvas.style = "margin-right: 45px;";

        var ctx = this.canvas.getContext("2d");

        const color1 = 'rgb(0, 133, 228)';
        const colorGluc = 'rgb(0, 133, 228)';
        const colorAlert = 'rgb(255, 94, 0)';
        const color1Op = 'rgba(0, 133, 228, 0.2)';
        const color1Tr = 'rgba(0, 133, 228, 0)';
        const colorSogliaGluc = 'rgb(0, 133, 228, 0.7)';


        var backgroundGradient = ctx.createLinearGradient(0, 0, 0, 450);
        backgroundGradient.addColorStop(0.7, color1Tr);
        backgroundGradient.addColorStop(0, color1Op);

        this.container.appendChild(this.canvas);

        if(debug) {
            console.debug('glucometer data', data);
        }

        this.convertData(data);

        this.chart = new Chart(this.canvas.id, {
            type: 'line',
            data: {
                labels: this.getLabels(),// this.labels,
                datasets: [{
                    //borderColor: 'rgb(238, 60, 143)',
                    borderColor: (data) => {
                        if((data.type == 'data') &&  (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.minValue && (parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.minValue))) ||
                                (this.options?.thresholds?.maxValue && (parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.maxValue)))
                            ){
                                return colorAlert;
                            }
                        }
                        return colorGluc;
                    },

                    borderWidth: 2,
                    radius: 3,
                    pointBackgroundColor: 'white',
                    data: this.data,
                    backgroundColor: backgroundGradient,
                    tension: 0,
                    // pointHoverBorderWidth: 0,
                    fill,
                    showLine
                }],
                thresholdsGluc: [
                    [this.options?.thresholds?.minValue, colorSogliaGluc, this.options?.thresholds?.enabled_threshold],
                    [this.options?.thresholds?.maxValue, colorSogliaGluc, this.options?.thresholds?.enabled_threshold],
                ],
            },
            options: {
                layout: {
                    padding: {
                        top: 25,
                    //     left: -10,
                    //     bottom: -10
                    }
                },
                animation: animation,
                interaction: {
                    intersect: false,
                    //mode: 'index',
                    axis: 'xy',
                    mode: 'point',
                },
                plugins: {
                    legend: false,
                    tooltip: {
                        displayColors: false,
                        position: 'nearest',
                        callbacks: {
                            title: function(tooltipItems) {
                                return moment(tooltipItems[0].raw.x).format('DD/MM/YYYY HH:mm');
                            },
                            label: function(tooltipItem) {
                                return tooltipItem.raw.y+' mg/dl';
                            },
                        }
                    },
                    
                },
                scales: {
                    x: {
                        type: 'linear',
                        min: this.fromDate ? this.fromDate.getTime() : null,
                        max: this.toDate ? this.toDate.getTime() :  null,
                        grid: {
                            borderWidth: 0,
                            color: function(line) {
                                return false;
                            }
                        },
                        ticks: {
                            display: true,
                            stepSize: this.getStepSize(),
                            // color: '#ccc',
                            font: {
                                size: 12,
                            },
                            callback: (val, index) => {
                                // Hide the label of every 2nd dataset
                                // return index % 2 === 0 ? moment(this.getLabelForValue(val)).format('DD/MM HH:mm') : '';
                                return this.labels ? moment(val).format(this.getLabelFormat()) : null;
                            },
                        },
                    },
                    y: {
                        type: 'linear',
                        min: initialMin,
                        max: initialMax,
                        grid: {
                            borderWidth: 0,
                            borderDash: [4],
                            color: function(line) {
                                return "rgba(75,75,75,0.2)";
                            }
                        },
                        ticks: {
                            display: true, //this will remove only the label
                            stepSize: 10,
                            color: colorGluc,
                            font: {
                                size: 12,
                            },
                            callback: function(value, index) {
                                return value + '  ';
                            }
                        },
                    },
                    y2: {
                        type: 'linear',
                        position: 'right',
                        min: initialMin,
                        max: initialMax,
                        grid: {
                            borderWidth: 0,
                            borderDash: [4],
                            color: function(line) {
                                return "rgba(75,75,75,0.2)";
                            }
                        },
                        ticks: {
                            display: true, //this will remove only the label
                            stepSize: 10,
                            color: colorGluc,
                            font: {
                                size: 12,
                            },
                            callback: function(value, index) {
                                return value + '  ';
                            }
                        },
                    },
                },
                responsive: true,
                maintainAspectRatio: true
            },
            plugins: [
                {
                    afterDatasetDraw: (chart) => {
                        let ctx = chart.ctx;
                        ctx.font = '12px Arial';
                        ctx.textBaseline = 'top';
                        ctx.textAlign = 'left';
        
                        const offsetWidth = ctx.canvas.offsetWidth;
                
                        ctx.fillStyle = color1; // label color
                        ctx.fillText('mg/dl', 34, 0);
                        this.drawCustomIcon(ctx, defaultIcon.src, 16, 0, 8, 8); // Disegna l'icona personalizzata


                        // Right Legend
                        //ctx.fillStyle = color3; // label color
                        ctx.fillStyle = color1; // label color
                        ctx.textAlign = 'right';
                        //this.drawCustomIcon(ctx, '/assets/icons/bpmIcon.svg', offsetWidth - 40, 0, iconWidth, iconWidth); // Disegna l'icona personalizzata
                        ctx.fillText('', offsetWidth - 1, 0);
                    },
                    thresholdPlugin: {
                    },
                }
            ]
        });

        this.autoScaling();

        this.chart.update();

        if(debug) {
            console.debug('glucometer done', this.labels, this.data);
        }
    }

    autoScaling() {

        if(debug) {
            console.log('GlucometerChart setData start cycle', this.data, this.data.length);
        }

        let min = initialMin;
        let max = initialMax;

        for(let i=0; i < this.data.length; i++) {
            if(this.data[i] == null) {
                continue;
            }

            const value = parseFloat(this.data[i].y);

            let newMax = Math.ceil((value + 20) / 10) * 10;
            if(debug) {
                console.debug('GlucometerChart setData test newMax', value, newMax, max);
            }
            if(max < newMax) {
                max = newMax;
            }

            let newMin = Math.trunc((value - 20) / 10) * 10;
            if(newMin < 0) {
                newMin = 0;
            }

            if(debug) {
                console.debug('GlucometerChart setData test newMin', value, newMin, min);
            }
            if(min > newMin) {
                min = newMin;
            }
        }
        
        if(debug) {
            console.log('GlucometerChart setData min max', min, max);
        }

        this.chart.options.scales.y.min = min;
        this.chart.options.scales.y.max = max;
        this.chart.options.scales.y2.min = min;
        this.chart.options.scales.y2.max = max;
    }


    convertData(data) {
        // this.labels = [];
        this.data = [];

        if(!!data && !!data.value) {
            for (const prop in data.value) {
                // console.log(`${prop} - ${data.value[prop]}`);
                // this.labels.push(prop);
                let millis = parseInt(prop) * 1000;
                this.data.push({
                    y: data.value[prop],
                    x: millis
                });
            }
        }

        if(debug) {
            console.debug('glucometerChart convertData', this.labels, this.data);
        }

    }

    setData(data, fromDate, toDate) {
        if(debug) {
            console.debug('glucometerChart setData', this.chart, this.chart.scales, fromDate, toDate);
        }

        this.fromDate = new Date(fromDate);
        this.toDate = new Date(toDate);

        this.chart.config.options.scales.x.min = this.fromDate.getTime();
        this.chart.config.options.scales.x.max = this.toDate.getTime();
        this.chart.config.options.scales.x.ticks.stepSize = this.getStepSize();
        this.convertData(data);

        this.chart.data.labels = this.getLabels();
        this.chart.data.datasets[0].data = this.data;

        this.autoScaling();

        this.chart.update();
    }

    getLabels() {
        let date = new Date(this.fromDate);
        let labels = [];
        // let debugs = [];

        while(date <= this.toDate) {
            labels.push(date.getTime());
            // date.setDate(date.getDate() + 1);
            date = new Date(date.getTime() + this.getStepSize());
            // debugs.push(moment(date.getTime()).format('DD/MM/YYYY HH:mm'));
        }

        // console.debug('labels', debugs);
        this.labels = labels;

        return labels;
    }

    getStepSize() {
        // console.debug('getStepSize', this.toDate - this.fromDate > 604800000 ? 86400000 : 14400000);
        return this.toDate - this.fromDate > 604800000 ? 86400000 : 14400000;
    }

    getLabelFormat() {
        // console.debug('getLabelFormat', this.fromDate, this.toDate, this.toDate - this.fromDate, 604800000 + 86400000, this.toDate - this.fromDate > 604800000 + 86400000);
        return this.toDate - this.fromDate > 604800000 + 86400000 ? 'DD/MM/YYYY' : 'DD/MM HH:mm';
    }

    toBase64Image(type, quality) {
        return this.chart.toBase64Image(type, quality);
    }

    // Funzione per disegnare un'icona personalizzata sul canvas
    drawCustomIcon(ctx, iconPath, x, y, width, height) {
        var img = new Image();
        img.src = iconPath;
        ctx.drawImage(img, x, y, width, height);
    }

}

var thresholdPlugin = {
    id: 'thresholdGluc',
    beforeDraw: function(chart, args) {

        let thresholdsWidth = 10;
        const shiftSoglia = 30;

        if (!chart.config.data.thresholdsGluc) 
            return;

        let yAxis = chart.scales['y'];

        chart.config.data.thresholdsGluc.forEach(function(value) {

            // value[0] = Valore soglia da disegnare
            // value[1] = Colore della linea
            // value[2] = Abilitazione soglia

            if(value[2] == 1){
                let y = yAxis.getPixelForValue(value[0]);
                chart.ctx.beginPath();
                chart.ctx.moveTo(shiftSoglia, y);
                chart.ctx.lineTo(thresholdsWidth+shiftSoglia, y);
                chart.ctx.lineWidth = 2;
                chart.ctx.strokeStyle = value[1];
                chart.ctx.stroke();
            }
        });

    }
};

// Aggiunge il plugin a Chart.js
Chart.register(thresholdPlugin);

window.GlucometerChart = GlucometerChart;